var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.759 10.2408C25.6018 10.0837 25.4056 9.97141 25.1906 9.91538C24.9755 9.85935 24.7494 9.86167 24.5356 9.92208H24.5239L9.52855 14.4721C9.28445 14.5423 9.06753 14.6852 8.90667 14.8817C8.74581 15.0783 8.64865 15.3192 8.62811 15.5724C8.60758 15.8255 8.66466 16.0789 8.79174 16.2988C8.91883 16.5187 9.10989 16.6947 9.33948 16.8033L16.0285 19.9713L19.1965 26.6604C19.2965 26.8746 19.4557 27.0557 19.6554 27.1824C19.855 27.309 20.0867 27.3759 20.3231 27.3752C20.359 27.3752 20.395 27.3736 20.4309 27.3705C20.6832 27.3501 20.9231 27.253 21.1186 27.0923C21.3141 26.9315 21.4558 26.7149 21.5246 26.4713L26.0715 11.476C26.0715 11.4721 26.0715 11.4682 26.0715 11.4643C26.1327 11.251 26.136 11.0252 26.0811 10.8102C26.0262 10.5952 25.915 10.3987 25.759 10.2408ZM20.3301 26.1135L20.3262 26.1244L17.2512 19.633L20.9418 15.9416C21.0541 15.8235 21.1158 15.6661 21.1137 15.5031C21.1116 15.3402 21.0459 15.1844 20.9307 15.0692C20.8154 14.9539 20.6597 14.8883 20.4967 14.8862C20.3337 14.8841 20.1764 14.9458 20.0582 15.058L16.3668 18.7486L9.87464 15.6736H9.88558L24.8746 11.1252L20.3301 26.1135Z",
    fill: "#DF3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralsBg);
export default __webpack_public_path__ + "static/media/referrals-bg.dbc91feeac02684c9f9161216727d30f.svg";
export { ForwardRef as ReactComponent };